import React, { ReactNode } from 'react';

import icon_blank from '../assets/img/common/icon_blank.svg';
import icon_download from '../assets/img/common/icon_download.svg';

type DownloadLinkProps = {
    href: string;
    children: ReactNode;
}
export const DownloadLink:React.FC<DownloadLinkProps> = (props) => {

    const { href, children } = props;

    return (
        <a href={href} className="c-link-text">
            {children}<span className="c-icon-text c-icon-text--ml"><svg width={16} height={17} aria-label="ファイルをダウンロードする"><use href={`${icon_download}#iconDownload`} /></svg></span>
        </a>
    )
}
type BlankLinkProps = {
    href: string;
    children: ReactNode;
}
export const BlankLink:React.FC<BlankLinkProps> = (props) => {

    const { href, children } = props;

    return (
        <a href={href} target="_blank" className="c-link-text">
            {children}<span className="c-icon-text c-icon-text--ml"><svg width={16} height={17} aria-label="別タブで開く"><use href={`${icon_blank}#iconBlank`} /></svg></span>
        </a>
    )
}